<template>
    <SingleOrder v-if="subSection" :id="subSection" />
    <ListOrders v-else />
</template>

<script>

import ListOrders from "./ListOrders.vue";
import SingleOrder from "./SingleOrder.vue";

export default {
    name: "ProfileOrders",
    components: {SingleOrder, ListOrders},
    props: ['subSection'],
    computed: {
        authenticated() {
            return this.isAuthenticated();
        },
    },
    watch: {
        authenticated() {
            this.checkIsLoading();
        }
    },
}
</script>

<style scoped>

</style>
